{
  "version": 1,
  "asset_id": "83f879dd-b1c6-406e-8472-01f05d72b8ff",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/83f879dd-b1c6-406e-8472-01f05d72b8ff/cortile-pietra-lavato-lombardia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/83f879dd-b1c6-406e-8472-01f05d72b8ff/cortile-pietra-lavato-lombardia.webp",
  "original_filename": "cortile-pietra-lavato-lombardia.webp",
  "size": 307066,
  "content_type": "image/webp",
  "created_at": "2026-09-02T15:21:03Z"
}
